import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "alert-body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "body-text" }
const _hoisted_4 = { class: "text-value" }
const _hoisted_5 = { class: "text-time" }
const _hoisted_6 = { class: "btn-text" }
const _hoisted_7 = { class: "btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alert", [_ctx.alertClass, _ctx.color]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "body-border" }, null, -1)),
      _createElementVNode("img", {
        src: _ctx.iconNormalized,
        class: "body-icon",
        width: "22",
        height: "22"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.timeNormalized), 1)
      ])
    ]),
    (_ctx.action)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.actionEvent && _ctx.actionEvent(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.actionTextNormalized), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "alert-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('Alert.close')), 1)
        ]))
  ], 2))
}